import { useMutation } from "@tanstack/react-query";
import {
  createAjoutRuchesStripeSession,
  createProduitDigitalStripeSession,
  validerPaiementSession,
} from "../services/paiement.service";

export const useValiderPaiementSession = () =>
  useMutation({
    mutationFn: validerPaiementSession,
  });

export const useCreateAjoutRuchesStripeSession = () =>
  useMutation({
    mutationFn: createAjoutRuchesStripeSession,
  });

export const useCreateProduitDigitalStripeSession = () =>
  useMutation({
    mutationFn: createProduitDigitalStripeSession,
  });
